import { render, staticRenderFns } from "./ExpansionPanelHeader.vue?vue&type=template&id=2d5edc09&scoped=true"
import script from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelHeader.vue?vue&type=style&index=0&id=2d5edc09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5edc09",
  null
  
)

export default component.exports